import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const QUERY = gql`
  query getThumbnails($productId: String!) {
    thumbnails(productId: $productId) {
      id
      productId
      images {
        filename
        contentType
        type
      }
    }
  }
`;

const useThumbnails = (productId) => {
  const { data, loading, error } = useQuery(QUERY, {
    variables: { productId },
  });

  return loading || error ? [] : data.thumbnails;
};

export default useThumbnails;
